<div
  [id]="pageId || 'order-list-payload-box'"
  [appHeaderPayloadId]="pageId || 'order-list-payload-box'"
>
  <ng-template [appHasAccess]="[Role.UpdateOrderArchive]">
    <app-payload-button
      titleKey="آرشیو گروهی"
      icon="archive"
      (clicked)="bulkArchive()"
      [disabled]="!tableConfig"
    ></app-payload-button
  ></ng-template>

  @if (!pageId) {
    <ng-template
      [appHasAccess]="[
        Role.CreateOrder,
        Role.CreateOrderSelf,
        Role.CreateOrderCapillary,
        Role.CreateOrderCapillarySelf,
      ]"
    >
      <app-add-button href="./create"></app-add-button
    ></ng-template>
  }
</div>

<app-table
  [isLoading]="!tableConfig"
  [tableConfig]="tableConfig"
  [hasFilters]="true"
  [hasSort]="true"
  [sortOptionGroups]="customerSortOptionGroups"
  (clickFiltersButton)="openFiltersModal()"
></app-table>
